// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"40":"1f9f50c7566b7299","3295":"19fccd85ac912cec","4125":"1c2e94a1a9916728","5483":"768148bb08f4b740","9682":"7d0ea7313df0e68c"}[chunkId] + ".js";
};